module.exports = "<table class=\"middleContainer2\">\r\n  <tr>\r\n      <td>\r\n          <div class=\"loginMiddle\">\r\n              <feishu-bind></feishu-bind>\r\n          </div>\r\n      </td>\r\n  </tr>\r\n</table>";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatBind/FeishuIndex.html
// module id = 225
// module chunks = 0